<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="panel panel-sm">
                            <div class="panel-heading">
                                <h2>Producten importeren</h2>
                                <p>Selecteer het csv bestand om te importeren.</p>
                                <br />
                                <strong>Belangrijk! Lees dit eerst.</strong>
                                <br />
                                Mocht je een .xls(x) bestand hebben. Sla deze dan eerst op als .csv bestand via Microsoft Excel
                                <br />
                                Er zijn een paar eisen waar dit bestand aan moet voldoen.
                                <li>Er mogen maar 10 kolommen bestaan in deze volgorde (<strong>categoryName</strong>;<strong>articleNumber</strong>;<strong>active</strong>;<strong>price</strong>;<strong>dutchTitle</strong>;<strong>frenchTitle</strong>;<strong>dutchDescription</strong>;<strong>frenchDescription</strong>;<strong>categoryCode</strong>;<strong>imageLocation</strong>)</li>
                                <li>Boven deze kolommen moet ook de titel staan respectievelijk <strong>categoryName</strong>;<strong>articleNumber</strong>;<strong>active</strong>;<strong>price</strong>;<strong>dutchTitle</strong>;<strong>frenchTitle</strong>;<strong>dutchDescription</strong>;<strong>frenchDescription</strong>;<strong>categoryCode</strong>;<strong>imageLocation</strong></li>
                                <li>Zorg dat de prijzen met decimalen zijn aangegeven met een punt (.) en niet met een komma (,) <strong>bijvoorbeeld:</strong> &euro;4.50 = 4.5</li>
                                <li>Bij de prijzen mag er <strong>geen</strong> &euro; teken staan (deze voeg ik zelf toe)</li>
                                <br />
                                <br />
                                Wanneer je een .csv bestand hebt geselecteerd zul je de wijzigingen hieronder in een tabel staan. Controleer of ze kloppen en of er geen gekke dingen in voorkomen.
                            </div>
                            <div class="panel-body">
                                <div class="form-group">
                                    <label for="csv_file" class="control-label col-sm-3 text-right">CSV bestand</label>
                                    <div class="col-sm-9">
                                        <input type="file" id="csv_file" name="csv_file" class="form-control" @change="loadCSV($event)">
                                    </div>
                                </div>
                                <br />
                                <br />

                                <table v-if="parse_csv.length > 0" class="table">
                                    <thead>
                                        <tr>
                                            <th v-for="key in parse_header"
                                                :class="{ active: sortKey == key }">
                                                {{ key }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tr v-for="csv in parse_csv">
                                        <td>
                                            {{csv.categoryName}}
                                        </td>
                                        <td>
                                            {{csv.articleNumber}}
                                        </td>
                                        <td>
                                            {{csv.active}}
                                        </td>
                                        <td>
                                            &euro;{{csv.price}}
                                        </td>
                                        <td>
                                            {{csv.dutchTitle}}
                                        </td>
                                        <td>
                                            {{csv.frenchTitle}}
                                        </td>
                                        <td>
                                            {{csv.dutchDescription}}
                                        </td>
                                        <td>
                                            {{csv.frenchDescription}}
                                        </td>
                                        <td>
                                            {{csv.categoryCode}}
                                        </td>
                                        <td>
                                            {{csv.imageLocation}}
                                        </td>
                                    </tr>
                                </table>
                                <div class="col-sm-4" v-if="parse_csv.length > 0">
                                    <button type="button" class="btn btn-danger" @click="submit()">Importeren</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BtFooter from './BTFooter.vue'

    export default {
        name: 'ProductsImport',
        data() {
            return {
                parse_header: [],
                parse_csv: [],
                sortOrders: {},
                sortKey: ''
            }
        },
        created() {
            document.title = 'Brabant-Tools | Producten importeren'
        },
        methods: {
            submit() {
                var _self = this
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om producten te importeren. Weet je zeker dat alles klopt?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Importeren',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.dispatch('importProducts', _self.parse_csv).then(() => {
                            if (this.areProductsImported) {
                                _self.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Producten zijn geïmporteerd!' })
                                _self.parse_csv = []
                            } else {
                                _self.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets misgegaan tijdens het importeren van de producten!' })
                            }
                        })
                    }
                })
            },
            csvJSON(csv) {
                var vm = this
                var lines = csv.split('\n')
                var result = []
                var headers = lines[0].split(';')
                vm.parse_header = lines[0].split(';')

                lines.filter(function (line) {
                    if (line === '') {
                        return false;
                    }
                    return true;
                }).map(function (line, indexLine) {
                    if (indexLine < 1) return

                    var obj = {}

                    var currentline = line.split(';')

                    headers.map(function (header, indexHeader) {
                        switch (indexHeader) {
                            case 0:
                                obj.categoryName = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 1:
                                obj.articleNumber = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 2:
                                obj.active = isNaN(parseInt(currentline[indexHeader].trim())) ? 1 : parseInt(currentline[indexHeader].trim())
                                break;
                            case 3:
                                obj.price = parseFloat(parseFloat(currentline[indexHeader].replace(',', '.').trim()).toFixed(2))
                                break;
                            case 4:
                                obj.dutchTitle = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 5:
                                obj.frenchTitle = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 6:
                                obj.dutchDescription = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 7:
                                obj.frenchDescription = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 8:
                                obj.categoryCode = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                            case 9:
                                obj.imageLocation = vm.removeQuotes(currentline[indexHeader].trim())
                                break;
                        }
                    })
                    if (obj.articleNumber)
                        result.push(obj)
                })
                return result
            },
            removeQuotes(str) {
                var vm = this
                if (str.charAt(0) === '"' && str.charAt(str.length - 1) === '"') {
                    return str.substr(1, str.length - 2).replace('""', '"');
                }
                return str;
            },
            loadCSV(e) {
                var vm = this
                if (window.FileReader) {
                    var reader = new FileReader()
                    reader.readAsText(e.target.files[0])
                    // Handle errors load
                    reader.onload = function (event) {
                        var csv = event.target.result
                        vm.parse_csv = vm.csvJSON(csv)
                    }
                    reader.onerror = function (evt) {
                        if (evt.target.error.name === 'NotReadableError') {
                            alert('Cannot read file!')
                        }
                    }
                } else {
                    alert('FileReader are not supported in this browser.')
                }
            }
        },
        computed: {
            ...mapGetters({
                areProductsImported: 'areProductsImported'
            })
        },
        components: {
            BtFooter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
